import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const tableauBordSocialData = [
    {
    title: "Tableau de Bord Social édition 2024",
    principalLink: "/documents/tableau-bord-social/TBS_2024.pdf",
    image: 'assets/annuaires/tableau.png',
    description: "Le tableau de bord 2024 révèle que la population burundaise a atteint 12 332 788 d'habitants avec un rapport de masculinité de 88 % en 2024, tandis que l'espérance de vie s'élève à 61 ans.",
    date: "2025-12-30",
    publicationDate: "2025-12-10",
  },
   {
    title: "Tableau de Bord Social édition 2023",
    principalLink: "/documents/tableau-bord-social/TBS_2023_DOCUMENT_FINAL.pdf",
    image: 'assets/annuaires/tableau.png',
    description: "Le tableau de bord 2022 révèle que la population burundaise a atteint  13 097 400 d'habitants avec un rapport de masculinité était 96,97% en 2023, tandis que l'espérance de vie s'élève à 60,6 ans.",
    date: "2024-12-30",
    publicationDate: "2024-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2022",
    principalLink: "/documents/tableau-bord-social/TBS-EDITION-2022.pdf",
    image: 'assets/annuaires/tableau.png',
    description: "Le tableau de bord 2022 révèle que la population burundaise a atteint 12,8 millions d'habitants avec un taux d'accroissement de 4,2%, tandis que l'espérance de vie s'élève à 60 ans et le taux de scolarisation primaire atteint 85,5%, malgré un taux de préscolarisation encore faible à 15%.",
    date: "2023-12-30",
    publicationDate: "2023-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2020",
    principalLink: "/documents/tableau-bord-social/TABLEAU-DE-BORD-SOCIAL-2020.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Le rapport 2020 révèle une croissance démographique rapide au Burundi avec 12,3 millions d'habitants (taux d'accroissement de 3,9%), une baisse encourageante de la mortalité infantile (56‰ en 2016 contre 106‰ en 1990) et maternelle (392 décès/100 000 naissances), tandis que l'espérance de vie atteint 59,1 ans malgré une fécondité encore élevée (5,5 enfants/femme).",
    date: "2021-12-30",
    publicationDate: "2021-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2018",
    principalLink: "/documents/tableau-bord-social/TBS-DECEMBRE-2019-Edition-2018.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Le Tableau de Bord Social 2018 révèle une population burundaise jeune (66% <25 ans) atteignant 11,8 millions d'habitants, avec des progrès notables : baisse de 52% de la mortalité infantile (47‰ en 2018 vs 103‰ en 2008) et augmentation de l'espérance de vie (57,6 ans), malgré des défis persistants comme une fécondité élevée (5,7 enfants/femme) et un taux de pauvreté de 64,6%.",
    date: "2019-12-30",
    publicationDate: "2019-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2017",
    principalLink: "/documents/tableau-bord-social/TBS-DECEMBRE-2018-Edition-2017.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Le Tableau de Bord Social 2017 du Burundi présente une population jeune de 11,5 millions d'habitants, avec des progrès en santé (baisse de 47% de la mortalité infantile depuis 1990) mais des défis persistants comme une fécondité élevée (5,4 enfants/femme) et une économie encore largement agricole (35% du PIB).",
    date: "2018-12-30",
    publicationDate: "2018-12-30",
  },
  {
    title: "Tableau de Bord Social édition 2015",
    principalLink: "/documents/tableau-bord-social/TBS-DECEMBRE-2016-Edition-2015.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Avec 9,8 millions d'habitants en 2015 dont la moitié a moins de 15 ans, le Burundi présente des indicateurs sociaux contrastés : espérance de vie faible (49 ans) et mortalité infantile élevée (103‰), mais progression des consultations prénatales et du budget santé (13,8% du budget national).",
    date: "2016-12-30",
    publicationDate: "2016-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2019",
    principalLink: "/documents/tableau-bord-social/TBS-edition-2019-VF-1.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Le Tableau de Bord Social 2019 du Burundi révèle une population jeune (12 millions d'habitants, dont 66% <25 ans) avec des progrès en santé (espérance de vie à 58,5 ans) mais des défis persistants : fécondité élevée (5,4 enfants/femme), faible scolarisation préscolaire (11,6%) et déperdition importante dans le suivi des consultations prénatales.",
    date: "2020-12-30",
    publicationDate: "2020-12-10",
  },
  {
    title: "Tableau de Bord Social édition 2009",
    principalLink: "/documents/tableau-bord-social/TBS-Mars-2011-Edition-2009.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Le rapport 2009 révèle un Burundi jeune (50% <15 ans) avec 8 millions d'habitants, marqué par une forte dépendance à l'agriculture (87% des ménages) et des indicateurs sociaux préoccupants : espérance de vie en baisse (49 ans), mortalité infantile élevée (103‰) et économie largement informelle (74% du PIB).",
    date: "2011-03-30",
    publicationDate: "2011-03-30",
  },/*
  {
    title: "Tableau de Bord Social édition 2016",
    principalLink: "/documents/tableau-bord-social/.pdf",
     image: 'assets/annuaires/tableau.png',
    description: "Ce document de 2016 propose une analyse complète des conditions sociales et démographiques, en dessinant un tableau des réalités vécues par la population.",
    date: "2021-12-30",
    publicationDate: "2022-01-10",
  }, */
];

function TableauBordSocial() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredTableau, setFilteredTableau] = useState(tableauBordSocialData);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredTableau(tableauBordSocialData);
    } else {
      const filtered = tableauBordSocialData.filter((tableau) => {
        const tableauYear = new Date(tableau.date).getFullYear();
        return tableauYear === parseInt(year);
      });
      setFilteredTableau(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Tableau de Bord Social
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Tableau de Bord Social est un recueil statistique pratique dont les données primaires proviennent de plusieurs sources. Sa production est le résultat d’une intense collaboration entre les structures qui produisent et analysent l’information statistique au Burundi. C'est un document publiant essentiellement les indicateurs sociaux-démographiques parmi lesquels certains ont été retenus dans le Cadre Stratégique de Croissance et de Lutte contre la Pauvreté de deuxième génération, du Plan National de Développement (PND 2018-2027) et des Objectifs de Développement Durables.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par l'année de publication"
            >
              <MenuItem value="Tous">Tous les rapports</MenuItem>
              {[...new Set(tableauBordSocialData.map((tableau) => new Date(tableau.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredTableau.slice(0, visibleCount).map((tableau, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={tableau.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 120, m: 2 }}
                        image={tableau.image}
                        alt={tableau.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a
                          href={tableau.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                          {<DownloadIcon />}{tableau.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {tableau.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(tableau.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredTableau.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Rapports
            </Button>
          )}
  <br />
  <br />
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
                onClick={() => navigate('/annuaire')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page principale
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default TableauBordSocial;